import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { signup } from '../applicant/signup';
import { UrlSignature } from '../common/apiEndpoint';

@Injectable()
export class SignUpService {
  constructor(
    private httpClient: HttpClient,
    private urlSignature: UrlSignature,
  ) {}

  getSignUpApplicants(year: string): Observable<signup[]> {
    const url = this.urlSignature.signUpApplicantsUrl + year;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as signup[]));
  }

  getSignUpApplicantById(signUpId: string): Observable<signup> {
    const url = this.urlSignature.signUpApplicantsUrl + '/' + signUpId;
    return this.httpClient.get(url).pipe(map((response) => response as signup));
  }

  getSignUpApplicantId(email: string): Observable<signup> {
    const url = this.urlSignature.signUpApplicantUrl + email + '/';
    return this.httpClient.get(url).pipe(map((response) => response as signup));
  }

  getSignUpApplicantsExcelFile(year: string): Observable<Blob> {
    const url = this.urlSignature.signUpApplicantsExcelDownloadUrl + '/' + year;
    return this.httpClient.get(url, { responseType: 'blob' });
  }

  getSignUpApplicantsCommentsExcelFile(): Observable<Blob> {
    const url = this.urlSignature.allCommentsExcel;
    return this.httpClient.get(url, { responseType: 'blob' });
  }
}
